const config = {


  //DEV/UAT
  //BASE_URL: "https://ford.excelloncloud.com/FORD", // prod
  //BASE_URL_OBS: "https://api-dev-yuj.excellonconnect.com/v2.0" ,
  //WS_BASE_URL: 'wss://ws-dev-yuj.excellonconnect.com/',
  //OSBLogin: { Username: 'OSBUAT', Password: '1234' },


  //Production
  BASE_URL: "https://api-fyuj.excellonconnect.com/v2.0",
  BASE_URL_OBS: "https://api-fyuj.excellonconnect.com/v2.0",
  WS_BASE_URL: 'wss://api-fyuj.excellonconnect.com/',
  OSBLogin: { Username: 'OSBPRD', Password: '123' },

  RefreshTimeStamp: 300000, // 5 min
  RefreshPageTimeStamp: 6000, // 1 min
  WelcomeBoard: '920403',
  GuestWorkshopBoard: '920404',
  Subscription: "30d07b14-fc9f-4140-bf1f-51def043a29d",
  ClientSecret: "64192ba1-6292-4095-977f-6925e2f0e544",
  ClientId: "919b3662-f5f4-473b-8e1f-443401eb06f9",

};

export default config;
